<template>
  <div class="reset-page">
    <nav-header module="忘记密码"></nav-header>
    <div class="main reset-wrapper">
      <ul class="step-list">
        <li v-for="(item,index) in steps" :key="index" :class="{on:index<=current-1}">
          <div class="num"><i>{{index+1}}</i></div>
          <div class="text">{{item}}</div>
        </li>
      </ul>
      <el-form ref="validForm"  :model="validForm" :rules="validRule" v-show="current==1">
        <p class="tip"><i class="el-icon-info"></i>使用验证过的手机号码找回密码！</p>
        <el-form-item  prop="phone" >
          <el-input size="medium" placeholder="请输入绑定手机号码"  v-model="validForm.phone"></el-input>
        </el-form-item>
        <div id="captchaPassword"></div>
        <el-form-item  prop="code">
          <el-input size="medium" placeholder="请输入验证码" v-model="validForm.code"></el-input>
          <el-button
            class="btn-code"
            @click="getCode"
            :disabled="btnDisabled"
          >
            {{codeBtnText}}
          </el-button>
        </el-form-item>
        <el-form-item >
          <el-button class="btn-primary" @click="validPhone">下一步</el-button>
        </el-form-item>
        <p class="tel">客服电话：<i class="">021-60956592</i></p>
      </el-form>
      <el-form ref="loginForm"  :model="loginForm" :rules="loginRule" v-show="current==2">
        <el-form-item prop="password">
          <el-input
            size="medium"
            show-password
            maxlength="20"
            v-model.trim="loginForm.password"
            placeholder="请输入6-20位新密码"
          ></el-input>
        </el-form-item>
        <el-form-item  prop="password2">
          <el-input
            size="medium"
            show-password
            maxlength="20"
            v-model.trim="loginForm.password2"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item >
          <el-button class="btn-primary" @click="confirmReset">保存</el-button>
        </el-form-item>
        <p class="tel">客服电话：<i class="">021-60956592</i></p>
      </el-form>
      <div class="success-box"  v-show="current==3">
        <i class="el-icon-success"></i>
        密码修改成功，
        <span class="btn-text" @click="toLogin">去登录</span>
      </div>
    </div>
    <gk-footer></gk-footer>
  </div>
</template>
<script>
import NavHeader from '@/components/navHeader'
import GkFooter from '@/components/footer'
import validate from '@/scripts/validate.js'
import { 
	ResetPwd,
	SendValidCode,
	CheckValidCode,

  SendMobileCode
} from '@/scripts/api.js'
let _dx=window._dx;
export default {
  components:{
    NavHeader,
    GkFooter,
  },
  data(){
    //校验手机号
		var validatePhone = (rule, value, callback) => {
			if (!validate.phone(value)) {
				callback(new Error('手机号格式不正确'));
			}  else {
				callback();
			}
		};
		//校验登录密码
		var validateLoginPass = (rule, value, callback) => {
			if (!validate.password(value)) {
				callback(new Error('密码必须是6-20位数字和字母!'));
			}  else {
				callback();
			}
		};
		//校验登录密码2
		var validateLoginPass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.loginForm.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
    return{
      steps:['填写手机号','重置密码','完成'],
      current:1,
      code:'',
      codeBtnText: "获取验证码",
      btnDisabled: false,
      timer: null,
      type:1,
			validForm:{
				phone:'',
				code:'',
			},
			loginForm:{
				password:'',
				password2:'',
			},
      validRule:{
				phone:[{require:true,message: '请输入手机号',trigger: 'blur'},{validator: validatePhone,trigger: 'blur'}],
				code:[{require:true,message: '请输入验证码',trigger: 'blur'}],
			},
			loginRule:{
				password:[{require:true,message: '请输入登录密码',trigger: 'blur'},{validator: validateLoginPass,trigger: 'blur'}],
				password2:[{validator: validateLoginPass2,trigger: 'blur'}]
			},
    }
  },
  created() {
    this.type=Number(this.$route.query.type) ||1;
  },
  methods: {
		//发送验证码
		getCode(){
      var that = this;
      this.$refs.validForm.validate(valid=>{
        // console.log(valid)
        if(valid) {
          this.myCaptcha = _dx.Captcha(document.getElementById('captchaPassword'), {
          appId: 'e8941fd8bdcac157c64dedb50d13d1f7', //appId，在控制台中“应用管理”或“应用配置”模块获取
          style: 'inline',
          width: 300,
          success: function (token) {
            SendMobileCode({
              phone: that.validForm.phone,
              codeType: 1,
              imgCodeToken:token,
              platform:'pcweb'
              }).then(r => {
              // myCaptcha.hide();
              if (r.Result == 1) {
                let time = 120;
                that.btnDisabled = true;
                that.timer = setInterval(() => {
                  time--;
                  that.codeBtnText = time + "s";
                  if (time <= 0) {
                  time = 120;
                  that.btnDisabled = false;
                  that.codeBtnText = "获取验证码";
                  clearInterval(that.timer);
                  }
                }, 1000);
                that.$toast(r.Message);
              } else {
                that.$toast(r.Message);
              }
            });
          },
          fail:function(err){
            console.log(err)
          }
        })
        this.myCaptcha.show();
        }
      })
			


















			// SendValidCode({
      //   phone:this.validForm.phone,
      //   codeType:1,
      // }).then(r => {
      //   if (r.Result == 1) {
      //     let time = 120;
      //     this.btnDisabled = true;
      //     this.timer = setInterval(() => {
      //       time--;
      //       this.codeBtnText = time + "s";
      //       if (time <= 0) {
      //         time = 120;
      //         this.btnDisabled = false;
      //         this.codeBtnText = "获取验证码";
      //         clearInterval(this.timer);
      //       }
      //     }, 1000);
      //     this.$toast(r.Message);
      //   } else {
      //     return this.$toast(r.Message);
      //   }
      // });
		},
		//验证手机号
		validPhone(){
			this.$refs.validForm.validate(valid=>{
				if(valid){
					CheckValidCode({
						CodeType:1,
						ValidateCode:this.validForm.code,
						Phone:this.validForm.phone
					}).then(r=>{
						if(r.Result==1){
							this.current=2;
							// this.$refs.validForm.resetFields();
							this.btnDisabled = false;
							this.codeBtnText = "获取验证码";
							clearInterval(this.timer);
						}else{
							this.$toast(r.Message);
						}
					})
				}
			})
		},
		//确认修改登录密码
		confirmReset(){
			this.$refs.loginForm.validate(valid=>{
				if(valid){
					ResetPwd({
						ValidCodePhoneNumber:this.validForm.phone,
						UserCode:this.type==1?'p'+this.validForm.phone:'e'+this.validForm.phone,
						Password:this.loginForm.password,
					}).then(r=>{
						if(r.Result==1){
							this.$toast('修改成功');
							this.$refs.loginForm.resetFields();
							this.current=3;
						}else{
							this.$toast(r.Message);
						}
					})
				}
			})
		},
    toLogin(){
      if(this.type==1){
        this.$router.push('/personLogin');
      }else{
        this.$router.push('/companyLogin');
      }
    }
  },
}
</script>
<style lang="scss">
.reset-page{
  padding-top: 68px;
  .reset-wrapper{
    min-height: 70vh;
  }
  .step-list{
    overflow: hidden;
    margin-bottom: 40px;
    margin-top: 40px;
    width: 540px;
    margin: 46px auto 30px;
    li{
      width: 180px;
      float: left;
      position: relative;
      text-align: center;
      &:before{
        content: "";
        position: absolute;
        left: 50%;
        top: 16px;
        width: 100%;
        height: 4px;
        // border-radius: 4px;
        background-color: #d2d2d2;
      }
      &:last-child:before{
        display: none;
      }
      .num{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: linear-gradient(0deg, rgba(214, 214, 214, 0.7), rgba(222, 222, 222, 0.7));
        margin: 0 auto;
        position: relative;
        i{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          font-family: arial;
          display: block;
          line-height: 30px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          text-align: center;
          background-color: #c9c9c9;
        }
      }
      .text{
        display: block;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-top: 12px;
      }
      &.on{
        &:before{
          background-color: #FF5908;
        }
        .num{
          i{
            background-color: #FF5908;
          }
        }
        .text{
          color:#FF5908;
        }
      }
    }
  }
  .el-form{
    width: 300px;
    margin: 0 auto;
    .tip{
      font-size: 14px;
      color: #666;
      line-height: 30px;
      margin-bottom: 10px;
      .el-icon-info{
        font-size: 24px;
        color: #FF5908;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .btn-code{
      width: 100px;
      position: absolute;
      right: 0;
      top: 50%;
      z-index: 2;
      height: 36px;
      line-height: 36px;
      background-color: #f75959;
      font-size: 14px;
      color: #fff;
      transform: translateY(-50%);
      cursor: pointer;
      padding: 0;
      border-radius: 0;
    }
    .btn-primary{
      display: block;
      width: 100%;
      height: 36px;
      line-height: 36px;
      padding: 0;
      border-radius: 0;
      &:hover {
          color: #ffffff;
          border-color: #f75959;
          background-color: #f75959;
      }
    }
    .tel{
      font-size: 16px;
      color: #333;
      line-height: 30px;
      i{
        color: #f75959;
      }
    }
  }
  .success-box{
    text-align: center;
    font-size: 16px;
    color: #333;
    .el-icon-success{
      font-size: 40px;
      color: rgb(0, 180, 0);
      vertical-align: middle;
      margin-right: 10px;
      margin-top: -3px;
    }
    .btn-text{
      color: #f75959;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
#captchaPassword {
  margin-bottom: 22px;
  .dx_captcha_basic_link img {
    display: none;
  }
}
</style>